export interface AppConfig {
  holidayCode: number;
  apiBaseUrl: string;
  msalConfig: {
    clientId: string;
    authority: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
  };
}

const environments: Record<string, AppConfig> = {
  development: {
    holidayCode:  904,
    apiBaseUrl: "https://ferieapi.enso.no/api/",
    msalConfig: {
      clientId: "491f0b99-8aa8-4bbf-8247-5621a11a4e93",
      authority: "https://login.microsoftonline.com/e91a9e2f-0ba3-43ac-8005-550f20b326fe",
      redirectUri: "http://localhost:3000",
      postLogoutRedirectUri: "http://localhost:3000"
    }
  },
  production: {
    holidayCode: 904,
    apiBaseUrl: "https://ferieapi.enso.no/api/",
    msalConfig: {
      clientId: "491f0b99-8aa8-4bbf-8247-5621a11a4e93",
      authority: "https://login.microsoftonline.com/e91a9e2f-0ba3-43ac-8005-550f20b326fe",
      redirectUri: "https://ferie.enso.no",
      postLogoutRedirectUri: "https://ferie.enso.no"
    }
  }
};

export const getConfig = (): AppConfig => {
  const env = process.env.REACT_APP_ENV || 'development';
  return environments[env] || environments.development;
};

export default getConfig();